import PropTypes from 'prop-types';
import icons from '../icon/icons';

export const iconButtonPropTypes = {
  /**
   * Determines if the button has a background.
   */
  hasBackground: PropTypes.bool,
  /**
   * Background color for the button.
   * Can be a valid CSS color string or one of the theme colors: 'primary', 'secondary'.
   */
  backgroundColor: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * Color for the button.
   * Can be 'default', 'inherit', 'primary', or 'secondary'.
   */
  color: PropTypes.oneOf([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * Hover color for the button.
   * Should be a valid CSS color string.
   */
  hoverColor: PropTypes.string,
  /**
   * The type of the icon to render.
   * Must match a key from the `icons` module.
   * @type {string}
   * @required
   */
  type: PropTypes.oneOf(Object.keys(icons)).isRequired,
  /**
   * Width of the button.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Height of the button.
   */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Shape of the button.
   * Can be 'circle', 'square', or 'roundedSquare'.
   */
  shape: PropTypes.oneOf(['circle', 'square', 'roundedSquare']),
  /**
   * Click event handler for the button.
   */
  onClick: PropTypes.func,
  /**
   * Size for the icon inside the button.
   * Can be 'small', 'medium', 'large' or any px value ie 58px.
   */
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'medium', 'large']),
    PropTypes.string,
    PropTypes.object,
  ]),
};

export const iconButtonDefaultProps = { color: 'primary' };
